import { Injectable } from "@angular/core";
import { mergeMapTo } from "rxjs/operators";
import { take } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);

  constructor(
  ) {
  }

  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken() {
    // we can change this function to request our backend service
    //return this.angularFireAuth.authState.pipe(take(1));
  }

  updateTokenLocal(userId, token) {
    localStorage.setItem(userId, token);
  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */
  requestPermission(userId) {
  
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
   
  }
}
